exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".histogram-container{width:100%;height:100%;position:relative;vertical-align:middle;box-sizing:border-box;padding:20px 0 0;margin:0 auto}.histogram-head{height:30px;width:100%;position:absolute;top:-10px;right:-8px;padding-left:30px;box-sizing:border-box}.histogram-head .mark{float:right;margin-right:15px}.histogram-head .color-gradient{display:inline-block;width:6px;height:2px;border-radius:2px;margin-bottom:4px;margin-right:0}.mark label{font-size:12px;display:inline-block}.histogram-axisy-title{color:hsla(0,0%,100%,.3);font-size:12px;position:absolute;left:6px;bottom:-16px}.histogram-content{height:100%}.tick text{stroke:#8788a1;opacity:.3;font-weight:lighter}.domain{stroke:rgba(136,136,161,.3)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-127ea028!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/charts/histogram-v/index.vue
// module id = 162
// module chunks = 0